<button type="button" class="btn btn-outline-primary">
    <img src="assets/img/icons/search.svg"/>
</button>